module.exports = __webpack_public_path__ + "static/media/tombstone.b6a192ee.svg";